import {z} from 'zod';

import {helpLinkSchema} from '../../../../provider/help-links/help-links-type';

export const knowledgeHelpVideoSchema = helpLinkSchema.merge(
    z.object({
        videoLink: z.string(),
        config: z.object({
            title: z.string(),
            description: z.string(),

            durationSec: z.number(),
            previewUrl: z.string(),

            visibleForCustomers: z.boolean(),
            priority: z.number().nullish(),
        }),
    })
);

export type KnowledgeHelpVideoType = z.infer<typeof knowledgeHelpVideoSchema>;

export const knowledgeMarketingEventSchema = helpLinkSchema
    .omit({
        documentationLink: true,
    })
    .merge(
        z.object({
            documentationLink: z.string(),
            config: z.object({
                date: z.string().refine((dateString) => {
                    try {
                        return new Date(dateString);
                    } catch {
                        return false;
                    }
                }),
                name: z.string(),
                visibleForCustomers: z.boolean(),
                buttonText: z.string(),
            }),
        })
    );

export type KnowledgeMarketingEventType = z.infer<typeof knowledgeMarketingEventSchema>;
